import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputQuantityComponent } from './input-quantity.component';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@app/shared/modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldsModule } from '../form-fields/form-fields.module';

@NgModule({
  declarations: [InputQuantityComponent],
  imports: [CommonModule, FormsModule, MaterialsModule, TranslateModule, FormFieldsModule],
  exports: [InputQuantityComponent],
})
export class InputQuantityModule {}
